module.exports = __webpack_public_path__ + "static/media/intro.880cc5df.jpg";